export class Input {
  jumpHeld = false;
  jumpPressed = false;
  duckHeld = false;
  pausePressed = false;

  private readonly keys = new Set<string>();
  private jumpBuffer = 0;
  private readonly canvas: HTMLCanvasElement;
  private touchStartY = 0;

  constructor(canvas: HTMLCanvasElement) {
    this.canvas = canvas;
    window.addEventListener("keydown", this.onKeyDown);
    window.addEventListener("keyup", this.onKeyUp);
    canvas.addEventListener("pointerdown", this.onPointerDown);
    canvas.addEventListener("pointerup", this.onPointerUp);
    canvas.addEventListener("pointercancel", this.onPointerUp);
    canvas.addEventListener("pointermove", this.onPointerMove);
  }

  dispose(): void {
    window.removeEventListener("keydown", this.onKeyDown);
    window.removeEventListener("keyup", this.onKeyUp);
    this.canvas.removeEventListener("pointerdown", this.onPointerDown);
    this.canvas.removeEventListener("pointerup", this.onPointerUp);
    this.canvas.removeEventListener("pointercancel", this.onPointerUp);
    this.canvas.removeEventListener("pointermove", this.onPointerMove);
  }

  beginFrame(): void {
    this.jumpPressed = this.jumpBuffer > 0;
    if (this.jumpBuffer > 0) this.jumpBuffer -= 1;
    this.pausePressed = false;
  }

  /** Clear buffered jump input (used when transitioning to gameplay) */
  clearBuffer(): void {
    this.jumpBuffer = 0;
    this.jumpPressed = false;
  }

  endFrame(): void {
    // jumpPressed consumed by game after beginFrame
  }

  private onKeyDown = (e: KeyboardEvent): void => {
    if (e.repeat) return;
    const k = e.code;
    this.keys.add(k);

    if (
      k === "Space" ||
      k === "ArrowUp" ||
      k === "KeyW" ||
      k === "KeyZ"
    ) {
      e.preventDefault();
      this.jumpHeld = true;
      this.jumpBuffer = 8;
    }
    if (k === "ArrowDown" || k === "KeyS") {
      e.preventDefault();
      this.duckHeld = true;
    }
    if (k === "Escape" || k === "KeyP") {
      e.preventDefault();
      this.pausePressed = true;
    }
  };

  private onKeyUp = (e: KeyboardEvent): void => {
    const k = e.code;
    this.keys.delete(k);
    if (
      k === "Space" ||
      k === "ArrowUp" ||
      k === "KeyW" ||
      k === "KeyZ"
    ) {
      this.jumpHeld = false;
    }
    if (k === "ArrowDown" || k === "KeyS") {
      this.duckHeld = false;
    }
  };

  private onPointerDown = (e: PointerEvent): void => {
    if (e.button !== 0 && e.pointerType === "mouse") return;
    this.canvas.setPointerCapture(e.pointerId);
    this.touchStartY = e.clientY;
    this.jumpHeld = true;
    this.jumpBuffer = 8;
  };

  private onPointerUp = (e: PointerEvent): void => {
    this.jumpHeld = false;
    this.duckHeld = false;
    try {
      this.canvas.releasePointerCapture(e.pointerId);
    } catch {
      /* ignore */
    }
  };

  private onPointerMove = (e: PointerEvent): void => {
    if (!this.jumpHeld && e.pressure === 0) return;
    const dy = e.clientY - this.touchStartY;
    if (dy > 40) {
      this.duckHeld = true;
      this.jumpHeld = false;
    }
  };
}
